import Image from 'next/image';
import { Box, TextButton } from '@zillow/constellation-10';
import UserIcon from '../../images/iconography/user-profile-green.inline.svg';
import { loginStatusLinkStyles, loginStatusStyles, managePropertiesStyles, profileIconStyles } from './styles';
import { css } from '@/styled-system/css';

type Props = {
  email: string;
  firstName?: string;
  loggedIn: boolean;
};

export default function LoginStatus({ email, firstName = '', loggedIn }: Props) {
  return (
    <Box css={loginStatusStyles}>
      <TextButton asChild textStyle="body-sm-bold" css={managePropertiesStyles}>
        <a href="">Manage my properties</a>
      </TextButton>

      <TextButton asChild textStyle="body-sm-bold" tone="neutral" css={loginStatusLinkStyles}>
        <a href={loggedIn ? 'https://hotpads.com/user/account' : undefined}>
          <Image src={UserIcon} width={16} height={16} alt="" className={css(profileIconStyles)} />
          {firstName || email}
        </a>
      </TextButton>
    </Box>
  );
}
